$('#b2bForm').submit(function (e) {
  e.preventDefault();
  let data = $(this).serialize();
  $.ajax({
    type: "post",
    url: "https://backend.turboant.com/index/api/saveWholesale",
    data: data,
    dataType: "json",
    success: function (res) {
      const {
        code
      } = res;
      if (code === 1) {
        $('.b2b-form-wrap').hide();
        $('.b2b-success-wrap').show();
      }
    },
    error: function (err) {
      console.log(err)
    }
  });
});